// Clases compartidas de las listas compactas de Administración de flotilla.
// Antes cada fila medía ~95 px (p-4, columnas con etiqueta debajo, botones
// p-2 con fondo sólido verde/rojo); el objetivo es 48-56 px por fila, con las
// acciones en gris y el color sólo al pasar el puntero.

/** Contenedor de la fila: una línea, alto mínimo 52 px. */
export const DENSE_ROW =
  "flex items-center gap-3 px-3 py-1.5 min-h-[52px] rounded-lg border transition-colors hover:border-primary-500/40";

/** Separación vertical entre filas. */
export const DENSE_LIST = "space-y-1.5";

/** Botón de acción de fila: ícono de 32×32 sin fondo hasta el hover. */
export const ICON_BTN =
  "relative h-8 w-8 shrink-0 inline-flex items-center justify-center rounded-md text-[15px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500";

/** Variante para borrar: rojo tenue, fondo rojo sólo en hover. */
export const ICON_BTN_DANGER = `${ICON_BTN} text-red-500/80 hover:text-red-500 hover:bg-red-500/10`;

/** Variante "conectado" (dispositivo/remolque ligado): azul sin bloque sólido. */
export const ICON_BTN_ON = `${ICON_BTN} text-blue-500 hover:bg-blue-500/10`;

/** Chip de estado de una línea. */
export const STATUS_CHIP =
  "inline-flex shrink-0 items-center px-2 py-0.5 rounded-full text-[11px] font-medium leading-4 whitespace-nowrap";
